import { BaseEntity, Representavel } from '../../models';
import { origemLancamentoCadastroSogivendas } from '../../models/origem-lancamento-cadastro';
import { Campanha } from '../campanhas/campanhas/campanha';
import { CanalVenda, CanalVendaID } from '../common/canais-venda/domain';
import { moedaReal } from '../common/moeda';
import { CondicaoPagamento } from '../condicao-pagamento';
import { Cotacao } from '../cotacao';
import { FormaPagamento } from '../forma-pagamento';
import { Integracao } from '../integracao';
import { LocalDeposito } from '../local-deposito';
import { LocalFaturamento } from '../local-faturamento';
import { MotivoPerdaVenda } from '../motivo-perda-venda';
import { Periodo } from '../periodo';
import { Pessoa } from '../pessoa';
import { Cliente } from '../pessoa/cliente';
import { Representante } from '../pessoa/representante';
import { Transportadora } from '../pessoa/transportadora';
import { TabelaPreco } from '../tabela-preco';
import { TabelaPrecoRevisaoSearch } from '../tabela-preco/revisoes';
import { Usuario } from '../usuario';
import { PedidoBonificacaoReferencia } from './bonificacao-referencia';
import { PedidoCancelar } from './cancelamento';
import { PedidoClassificacaoCliente } from './classificacao-cliente';
import { PedidoConfirmavel } from './confirmar';
import { PedidoDRP } from './drp/pedido/pedido';
import { PedidoDuplicater } from './duplicate';
import { PedidoEmailer } from './email';
import { PedidoFilho } from './filho';
import { PedidoEditavel } from './form';
import { PedidoConfirmavelErp, PedidoIntegraterErp } from './integration-erp';
import { IPedidoPagamento } from './interfaces/pedido-pagamento.interface';
import { IPedidoEmAberto } from './interfaces/pedido-em-aberto.interface';
import { ITituloVencido } from './interfaces/titulo-vencido.interface';
import { PedidoItem } from './item';
import { PedidoNotaFiscal } from './nota-fiscal';
import { PedidoPai } from './pai';
import { PedidoAmostravel } from './pedido-amostravel';
import { PedidoPrazoPagamento } from './prazo-pagamento';
import { PedidoReporter } from './report';
import { PedidoRetornoAmostraHistorico } from './retorno-amostra';

export class Pedido implements BaseEntity,
    Representavel, PedidoEmailer, PedidoReporter, PedidoDuplicater,
    PedidoCancelar, PedidoEditavel, PedidoConfirmavel, PedidoConfirmavelErp,
    PedidoIntegraterErp, PedidoAmostravel, IPedidoPagamento {
    readonly id: number;
    createdAt: Date;
    idUsuarioCreated: number;
    usuarioCreated: Usuario;
    updatedAt: Date;
    idUsuarioUpdated: number;
    usuarioUpdated: Usuario;
    idEmpresa: number;
    origemLancamento: number;
    numero: number;
    tipoVenda: number;
    /** Operação de um pedido de venda */
    operacaoVenda: number;
    /** Finalidade do pedido */
    finalidade: number;
    status: number;
    statusAmostra: number;
    dataEmissao: Date;
    mesEmissao: number;
    trimestreEmissao: number;
    semestreEmissao: number;
    anoEmissao: number;
    /** Data em que um pedido foi confirmado (salvo com status de Confirmado) */
    dataConfirmacao: Date;
    idUsuarioConfirmacao: number;
    dataCarregamento: Date;
    idPeriodo: number;
    periodo: Periodo;
    idPessoa: number;
    pessoa: Pessoa;
    idRepresentante: number;
    representante: Representante;
    numeroPedidoCliente: string;
    exportacao: boolean;
    moeda: number;
    taxaCambio: number;
    tipoPagamento: number;
    prazosPagamento: PedidoPrazoPagamento[];
    idCondicaoPagamento: number;
    condicaoPagamento: CondicaoPagamento;
    idFormaPagamento: number;
    formaPagamento: FormaPagamento;
    percDesconto: number;
    quantidadeTotal: number;
    valorItens: number;
    valorItensMoeda: number;
    valorTotal: number;
    valorTotalMoeda: number;
    percDescontoMedio: number;
    prazoMedio: number;
    anotacao: string;
    mensagemNotaFiscal: string;
    /** Percentual de tolerância nas quantidades dos itens do pedido */
    percQuantidadeTolerancia: number;

    // Canal de Venda
    idCanalVenda: number;
    canalVenda: CanalVenda;
    numeroCanalVenda: string;

    // Cupons de Desconto
    cuponsDesconto: string[];

    // Conta e Ordem
    /** Operação de conta e ordem do pedido */
    operacaoContaOrdem: number;
    idPessoaContaOrdem: number;
    pessoaContaOrdem: Pessoa;

    // Frete
    tipoFrete: number;
    idTransportadora: number;
    transportadora: Transportadora;
    valorTotalFrete: number;
    valorTotalFreteMoeda: number;
    tipoFreteRedespacho: number;
    idTransportadoraRedespacho: number;
    transportadoraRedespacho: Transportadora;

    // Cancelamento
    origemCancelamento: number;
    dataCancelamento: Date;
    idUsuarioCancelamento: number;
    usuarioCancelamento: Usuario;
    idMotivoCancelado: number;
    motivoCancelado: MotivoPerdaVenda;
    motivoCancelamento: string;

    motivoReprovado: string;

    // Tabela de Preço
    idTabelaPreco: number;
    // codigoIntegracaoErpTabelaPreco: string;
    // nomeTabelaPreco: string;
    tabelaPreco: TabelaPreco;
    idTabelaPrecoRevisao: number;
    tabelaPrecoRevisao: TabelaPrecoRevisaoSearch;
    moedaTabelaPreco: number;
    atualizarTabelaPrecoPessoa: boolean;

    // Itens
    itens: PedidoItem[];

    notasFiscais: PedidoNotaFiscal[];
    filhos: PedidoFilho[];

    // D.R.P (Demonstração do Resultado do Pedido)
    drp: PedidoDRP;

    // Pesos
    pesoBruto: number;
    pesoLiquido: number;

    setorGep: number;
    dataAnaliseFinanceiro: Date;
    dataLiberadoExpedicao: Date;
    dataLiberadoFaturamento: Date;
    dataLiberadoColeta: Date;
    dataColeta: Date;
    dataPrevisaoEntrega: Date;
    dataEntrega: Date;
    quantidadeVolumesPrevistos: number;
    gepFinanceiro: number;
    gepFinanceiroHoras: number;
    gepComercial: number;
    gepComercialHoras: number;
    gepExpedicao: number;
    gepExpedicaoHoras: number;
    gepFaturamento: number;
    gepFaturamentoHoras: number;
    gepColeta: number;
    gepColetaHoras: number;
    gepTransportadora: number;
    gepTransportadoraHoras: number;
    gepGeral: number;
    gepGeralHoras: number;

    // GEP PCP
    /** Flag para informar se está confirmando o PCP do pedido/orçamento */
    isConfirmandoPCP: boolean;
    dataInicioGepPCP: Date;
    anotacaoEnvioPCP: string;
    dataTerminoGepPCP: Date;
    idUsuarioConfirmacaoPCP: number;
    nomeUsuarioConfirmacaoPCP: string;
    avatarURLUsuarioConfirmacaoPCP: string;
    anotacaoConfirmacaoPCP: string;
    gepPCP: number;
    gepPCPHoras: number;

    // GEP Produção
    idUsuarioInicioAguardandoProducao: number;
    dataInicioAguardandoProducao: Date;
    idUsuarioTerminoAguardandoProducao: number;
    dataTerminoAguardandoProducao: Date;
    gepAguardandoProducao: number;
    gepAguardandoProducaoHoras: number;

    /** Se o pedido é um pedido filho (originado através de um outro pedido (o pedido pai)) */
    pedidoFilho: boolean;
    idPedidoPai: number;
    pedidoPai: PedidoPai;
    idCotacao: number;
    cotacao: Cotacao;
    idLocalDeposito: number;
    localDeposito: LocalDeposito;
    valorDespachanteAduaneiro: number;
    valorDespachanteAduaneiroMoeda: number;
    valorAgenteCargas: number;
    valorAgenteCargasMoeda: number;
    valorCertificadoOrigem: number;
    valorCertificadoOrigemMoeda: number;
    valorCertificadoTransacao: number;
    valorCertificadoTransacaoMoeda: number;
    valorFreteMercadoInterno: number;
    valorFreteMercadoInternoMoeda: number;
    valorDespesaArmazem: number;
    valorDespesaArmazemMoeda: number;
    valorTotalExportacao: number;
    valorTotalExportacaoMoeda: number;

    // Pedido não liberado
    motivoNaoLiberado: number;
    dataNaoLiberado: Date;
    dataLiberado: Date;
    idUsuarioLiberado: number;
    nomeUsuarioLiberado: string;
    avatarURLUsuarioLiberado: string;
    justificativaLiberado: string;

    // Pedido Não Liberado - Desconto Máximo dos Itens Excedente
    liberadoManualmentePercDescontosMaximosItensExcedidos: boolean;
    dataLiberadoPercDescontosMaximosItensExcedidos: Date;
    idUsuarioLiberadoPercDescontosMaximosItensExcedidos: number;
    nomeUsuarioLiberadoPercDescontosMaximosItensExcedidos: string;
    avatarURLUsuarioLiberadoPercDescontosMaximosItensExcedidos: string;
    justificativaLiberadoPercDescontosMaximosItensExcedidos: string;

    // Pedido Não Liberado - Bonificações
    valorRegraNaoLiberado: number;
    tipoRegraBonificacaoNaoLiberado: number;
    valorBonificacaoNaoLiberado: number;
    percBonificacaoNaoLiberado: number;
    percBonificacaoMaximaNaoLiberado: number;
    liberadoManualmenteBonificacaoExcedente: boolean;
    dataLiberadoBonificacaoExcedente: Date;
    idUsuarioLiberadoBonificacaoExcedente: number;
    nomeUsuarioLiberadoBonificacaoExcedente: string;
    avatarURLUsuarioLiberadoBonificacaoExcedente: string;
    justificativaLiberadoBonificacaoExcedente: string;


    // Pedido Não Liberado - Limite de Crédito
    limiteCreditoDisponivelNaoLiberado: number;
    valorEmAbertoNaoLiberado: number;
    saldoLimiteCreditoNaoLiberado: number;
    pedidosEmAbertoNaoLiberado: IPedidoEmAberto[];

    // Pedido Não Liberado - Inadimplência (Títulos Vencidos)
    quantidadeTitulosVencidosNaoLiberado: number;
    valorTitulosVencidosNaoLiberado: number;
    titulosVencidosNaoLiberado: ITituloVencido[];

    pedidosBonificacoesReferencias: PedidoBonificacaoReferencia[];
    duplicado: boolean; // Se o pedido foi duplicado
    idPedidoDuplicadoReferencia: number; // Pedido de referência da duplicação
    idLocalFaturamento: number;
    localFaturamento: LocalFaturamento;

    // Histórico do retorno das amostras
    retornoAmostraHistorico: PedidoRetornoAmostraHistorico[];

    // Classificações
    classificacoesClientesNome: string;
    classificacoesClientes: PedidoClassificacaoCliente[];

    // Negócio
    idNegocio: number;
    numeroNegocio: number;
    idFunilVendaEtapaOportunidade: number;
    tipoFunilVendaEtapaOportunidade: number;
    nomeFunilVendaEtapaOportunidade: string;
    corFunilVendaEtapaOportunidade: number;
    podeSolicitarRevisaoOrcamento: boolean
    podeEditarRevisaoOrcamento: boolean;
    podeRevisarOrcamento: boolean;

    // Campanha
    possuiCampanha: boolean;
    idCampanha: number;
    numeroCampanha?: number;
    nomeCampanha?: string;
    statusCampanha?: number;
    idAreaCampanha?: number;
    campanha: Campanha;

    // Orçamentos
    paletizacao: boolean;
    aplicaClausulaReajuste: boolean;
    precoFixoAte: Date;
    responsavelCliente: string;
    responsavelEmpresa: string;
    // Proposta Comercial
    diasValidadePropostaComercial: number;
    dataValidadePropostaComercial: Date;
    propostaComercialVencida: boolean;
    propostaComercialVencidaDias: number;

    // Revisões
    /** Flag para informar se está revisando o pedido/orçamento */
    isRevisando: boolean;
    // Dados da solicitação da revisão atual
    dataSolicitacaoRevisao: Date;
    idUsuarioSolicitacaoRevisao: number;
    nomeUsuarioSolicitacaoRevisao: string;
    avatarURLUsuarioSolicitacaoRevisao: string;
    idMotivoSolicitacaoRevisao: number;
    nomeMotivoSolicitacaoRevisao: string;
    justificativaSolicitacaoRevisao: string;
    // Dados da revisão
    dataRevisao: Date;
    idUsuarioRevisao: number;
    nomeUsuarioRevisao: string;
    avatarURLUsuarioRevisao: string;

    // Análise Cliente
    // Em análise do cliente
    dataEmAnaliseCliente: Date;
    diasEmAnaliseCliente: number;
    idUsuarioEmAnaliseCliente: number;
    nomeUsuarioEmAnaliseCliente: string;
    avatarURLUsuarioEmAnaliseCliente: string;
    // Impressão do documento para envio para o cliente
    dataImpressaoAnaliseCliente: Date;
    idUsuarioImpressaoAnaliseCliente: number;
    nomeUsuarioImpressaoAnaliseCliente: string;
    avatarURLUsuarioImpressaoAnaliseCliente: string;
    // Enviado para o cliente
    dataEnviadoAnaliseCliente: Date;
    idUsuarioEnviadoAnaliseCliente: number;
    nomeUsuarioEnviadoAnaliseCliente: string;
    avatarURLUsuarioEnviadoAnaliseCliente: string;
    // Retorno do cliente
    dataRetornoAnaliseCliente: Date;
    idUsuarioRetornoAnaliseCliente: number;
    nomeUsuarioRetornoAnaliseCliente: string;
    avatarURLUsuarioRetornoAnaliseCliente: string;

	// Simulação
	idPedidoSimulado: number;
	cenarioSimulacao: number;
	descricaoCenarioSimulacao: string;
    simulacaoAplicada: boolean;
	dataAplicacaoSimulacao: Date;
	idUsuarioAplicacaoSimulacao: number;
	usuarioAplicacaoSimulacao: Usuario;

    // Clicheria
    statusClicheria: number;

    // Integração ERP
    /** Flag para informar se está exportando para o ERP */
    isExportingERP: boolean;
    idIntegracaoErp: number;
    integracaoErp: Integracao;
    nomeIntegracaoErp: string;
    logoURLPlataformaIntegracaoErp: string;
    numeroErp: string;
    integradoErp: boolean;
    integracaoErpSistema: number;
    dataIntegracaoErp: Date;
    idUsuarioExportErp: number;
    dataUltimaIntegracaoErp: Date;
    executandoIntegracaoSalvarErp: boolean;

    // Integração E-commerce
    idIntegracaoEcommerce: number;
    integracaoEcommerce: Integracao;
    nomeIntegracaoEcommerce: string;
    logoURLPlataformaIntegracaoEcommerce: string;
    idEcommerce: string;
    numeroEcommerce: string;
    dataIntegracaoEcommerce: Date;
    dataUltimaIntegracaoEcommerce: Date;

    // Atributos Auxiliares
    idCliente: number;
    cliente: Cliente;
    percAliquotaIpi: number;
    ipiIsento: boolean;

    constructor() {
        // this.tipoVenda = venda.id;
        // this.status = pedidoConfirmado.id;
        this.origemLancamento = origemLancamentoCadastroSogivendas.id;
        this.idCanalVenda = CanalVendaID.DIRETO;
        this.dataEmissao = new Date();
        this.valorItens = 0;
        this.valorItensMoeda = 0;
        this.valorTotal = 0;
        this.valorTotalMoeda = 0;
        this.itens = [];
        this.notasFiscais = [];
        this.filhos = [];
        this.prazosPagamento = [];
        this.quantidadeVolumesPrevistos = 0;
        this.moedaTabelaPreco = moedaReal.id;
        this.moeda = moedaReal.id;
        this.pedidosBonificacoesReferencias = [];

        this.atualizarTabelaPrecoPessoa = false;
        this.drp = new PedidoDRP();
    }
}
